import instance from "../../../api";

const notificationAnalyticsApi = {
    getAutoNotificationAnalytics: async (branch_id) => {
        return await instance().get(`/analytics/branches/${branch_id}/auto_notifications`)
            .then(res => res.data.data)
    },
}

export default notificationAnalyticsApi;
